<template>
    <div>
        <b-card v-if="form" class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isEdit ? 'Update User' : 'Buat User' }}</h5>
            </b-card-header>
            <b-card-body>
                <div class="form-group">
                    <label>Nama</label>
                    <input v-validate="'required'" v-model="form.name" type="text" name="name" class="form-control">
                    <span class="text-danger">{{ errors.first('name') }}</span>
                </div>
                <div class="form-group">
                    <label>Username</label>
                    <input v-validate="'required'" v-model="form.username" type="text" name="username" class="form-control">
                    <span class="text-danger">{{ errors.first('username') }}</span>
                </div>
                <!-- <div class="form-group">
                    <label>Email</label>
                    <input v-validate="'required|email'" v-model="form.email" type="text" name="email" class="form-control">
                    <span class="text-danger">{{ errors.first('email') }}</span>
                </div> -->

                <div class="form-group">
                    <label>Password</label>
                    <input v-validate="isEdit ? '' : 'required'" v-model="form.password" type="password" name="password" class="form-control" autocomplete="false">
                    <span class="text-danger">{{ errors.first('password') }}</span>
                </div>

                <div class="form-group" v-if="teams.length">
                    <label>Team</label>
                    <multiselect :disabled="value && value.type == 'super-admin'" v-validate="'required'" name="team" v-model="form.current_team" :options="teams" :placeholder="'Pilih team'" :searchable="true"
                        label="name" track-by="id" :allowEmpty="false" :show-labels="false"></multiselect>
                    <span class="text-danger">{{ errors.first('team') }}</span>
                </div>

                <div class="form-group" v-if="!hasAllGudangs">
                    <label class="form-control-label">Gudang</label>
                    <div class="input-group mb-0 d-flex">
                        <multiselect :class="'w-auto flex-grow-1'" name="gudang" v-model="gudang" :options="gudangOptions" :placeholder="'Pilih gudang'" :searchable="true"
                            label="name" track-by="id" :show-labels="true"></multiselect>
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="selectGudang = true"><i class="fas fa-search"></i> Pilih</button>
                        </div>
                    </div>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                <button @click="save" type="button" class="btn btn-primary mr-2">Simpan</button>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectGudang" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :selected="gudangOptions" @selected="gudangSelected" @cancel="selectGudang = false"></gudang-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import GudangSelector from '../gudangs/Selector';

export default {
    name: "users-form",

    props: {
        isEdit: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
        Multiselect,
        GudangSelector,
    },

    data() {
        return {
            form: {
                id: '',
                name: '',
                username: '',
                email: '',
                password: '',
                current_team: null,
            },
            gudang: null,
            teams: [],
            selectGudang: false,
            gudangOptions: [],
        }
    },

    created() {
    },

    mounted() {
        if (this.isEdit) {
            this.initForm();
        }

        this.loadTeams();
    },

    computed: {
        hasAllGudangs() {
            if (!this.form.current_team) {
                return true;
            }
            return [
                'SUPER DUPER ADMIN',
                'SUPER ADMIN',
                'OWNER',
                'MANAGER KEUANGAN',
            ].includes(this.form.current_team.name)
        },
    },

    watch: {
        value() {
            this.initForm();
        }
    },

    methods: {
        initForm() {
            let self = this;
            self.form = Object.assign({}, self.value);
            if (self.value.user_gudang) {
                self.gudangOptions.push(Object.assign({}, self.value.user_gudang.gudang));
            }
            self.gudang = self.value.user_gudang ? Object.assign({}, self.value.user_gudang.gudang) : null;
        },

        save() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self._save();
                }
            });
        },

        _save() {
            let self = this;

            let data = {
                name: self.form.name,
                username: self.form.username,
                // email: self.form.email,
                password: self.form.password ? self.form.password : null,
                current_team_id: self.form.current_team ? self.form.current_team.id : null,
                gudang_id: self.hasAllGudangs ? null : (self.gudang ? self.gudang.id : null),
            }

            self.$Progress.start();
            axios({
                method: self.isEdit ? 'put' : 'post',
                url: self.isEdit ? '/api/users/'+self.form.id : '/api/users',
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.$Progress.finish();
                self.$emit('saved');
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        loadTeams() {
            let self = this;

            self.$Progress.start();
            axios.get('/api/teams')
                .then(function (response) {
                    self.teams = response.data.data;
                    self.$Progress.finish();
                })
                .catch(function (error) {
                    self.requestFailed(error);
                });
        },

        gudangSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.gudang = Object.assign({}, gudang);
            self.selectGudang = false;
        },
    },
}
</script>
